var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "unusual", staticStyle: { display: "inline-block" } },
    [
      _c("yxt-tooltip", { attrs: { content: _vm.content, placement: "top" } }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "inline-block",
              color: "#f5222d",
              cursor: "pointer",
            },
          },
          [
            _c("yxt-svg", {
              staticClass: "d-icon ml12 unusual-middle",
              attrs: {
                color: "#F5222D",
                width: "20px",
                height: "20px",
                "icon-class": "info-cirlce-o",
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }